import { Dict } from '@/src/helpers/common.types'

export const gtmDataLayerPush = (eventObject: Dict<unknown>) => {
  window.dataLayer?.push(eventObject)
}
